export default function Formats() {
  const formats = [
    { icon: 'ri-building-2-line', title: 'Корпоративный тренинг', desc: 'Очное обучение команды на территории заказчика или в оборудованном конференц-зале. Полное погружение.', features: ['2–3 дня', 'До 16 участников', '80% практики'] },
    { icon: 'ri-global-line', title: 'Онлайн-формат', desc: 'Интерактивное обучение через видеоконференции с использованием цифровых инструментов.', features: ['Гибкий график', 'Любая география', 'Запись сессий'] },
    { icon: 'ri-stack-line', title: 'Модульное обучение', desc: 'Серия коротких модулей с интервалами для практики. Оптимально для глубокого усвоения.', features: ['2–12 недель', 'Домашние задания', 'Разбор прогресса'] },
    { icon: 'ri-refresh-line', title: 'Сопровождение', desc: 'Долгосрочная поддержка команды после тренинга. Аудит, корректировка, наставничество.', features: ['1–6 месяцев', 'Аудит звонков', 'Поддержка в чате'] },
    { icon: 'ri-flashlight-line', title: 'Интенсив', desc: 'Максимально сжатый формат для быстрой прокачки ключевых навыков за 1–2 дня.', features: ['1–2 дня', '6–8 часов/день', 'Высокая динамика'] },
    { icon: 'ri-settings-3-line', title: 'Индивидуальная программа', desc: 'Комбинация форматов под специфику бизнеса. Гибкий подход к построению обучения.', features: ['Персональный план', 'Поэтапная реализация', 'Комплексный подход'] },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Форматы <strong>тренинга по продажам для сотрудников</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Выберите формат, который соответствует задачам и возможностям вашей компании. При необходимости — комбинируем.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((format, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${format.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{format.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{format.desc}</p>
              <div className="flex flex-wrap gap-2">
                {format.features.map((feat, j) => (
                  <span key={j} className="text-xs bg-teal-50 text-teal-700 px-2.5 py-1 rounded-full font-medium">{feat}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}